import React from "react";
import SEO from "../components/SEO";
import content from "../data/contentData.json";
export default function Contacts() {
  const data = content.contacts;
  return (
    <main className="container">
      <SEO title={data.title} description={data.description} keywords={data.keywords}/>
      <h1 className="section-title">{data.title}</h1>
      <div className="mt-4 prose max-w-none" dangerouslySetInnerHTML={{__html: data.text}} />
      <p className="mt-4">Телефон: <a href="tel:+79163328259" className="text-blue-600 hover:underline">8-916-332-82-59</a></p>
      <p>Email: <a href="mailto:laptshka@mail.ru" className="text-blue-600 hover:underline">laptshka@mail.ru</a></p>
    </main>
  );
}
